/* istanbul ignore file */ // not fully implemented yet
import React, { useMemo } from 'react';
import { HelpButton } from '@bingads-webui-react/help-popup';
import { ColorPalette, ColorAddButton, useCheckDuplicateColor } from '@bingads-webui-campaign-react/ads-color-picker';
import { Body1Strong, mergeClasses, Skeleton, SkeletonItem } from '@fluentui/react-components';
import { useStyles, getskeletonStyles } from './style';
import {
  AdsStudioDisplayColorPickerProps
} from './type';


const ListSkeleton = () => {
  const classes = getskeletonStyles();
  return (
    <Skeleton className={classes.row}>
      <SkeletonItem className={classes.item} />
      <SkeletonItem className={classes.item} />
    </Skeleton>
  );
};

// WILL CHANGE ID ONCE DATA START COMING FROM API
export const AdsStudioDisplayColorPicker: React.FC<AdsStudioDisplayColorPickerProps> = React.memo(({
  title,
  isLoading,
  i18n,
  color,
  helpTopic,
  helpLabel,
  paletteData = [],
  maxColors = 2,
  onUpdate,
  onDelete,
}) => {
  const totalColors = paletteData.length;
  const classes = useStyles();
  const renderHelpBubble = useMemo(() => (
    <div className={classes.helpButton}>
      { helpTopic && (
        <HelpButton
          topic={helpTopic}
          aria-label={helpLabel}
        />
      )}
    </div>
  ), [classes.helpButton, helpLabel, helpTopic]);
  const { isDuplicate, onUpdateColor } = useCheckDuplicateColor({ paletteData, allowDuplicates: false, onUpdate });

  return (
    <div
      className={mergeClasses('display_color_picker', classes.displayColorPicker)}
    >
      <div className={classes.titleContainer}>
        <Body1Strong>{title}</Body1Strong>
        {renderHelpBubble}
      </div>
      {isLoading ?
        <ListSkeleton /> :
        <div className={mergeClasses('color_palette', classes.colorPalette)}>
          {paletteData.map(colorData => (
            colorData && <ColorPalette paletteColorSize="36px" palletteBoxSize="42px" hideCaption isDuplicate={isDuplicate} showEditBtn={!(colorData as any).isBrandKitColor} i18n={i18n} defaultSelected={colorData.HexCode === color} key={colorData.Name} colorData={colorData} onDelete={((colorData as any).isBrandKitColor || totalColors === 1) ? null : onDelete} updateColor={onUpdate} />
          ))}
          {(totalColors < maxColors) && <ColorAddButton paletteColorSize="36px" palletteBoxSize="42px" isDuplicate={isDuplicate} i18n={i18n} totalColors={totalColors} updateColor={onUpdateColor} />}
        </div>
      }
    </div>
  );
});
